export class RcsAppConfig{
  //public odoo_path:string = '/odoo-test'
  public odoo_path:string = 'https://extern.hogakaprofi.de:8080'
  public odoo_db:string = 'rws-2018-test'
  //public odoo_db:string = 'rws-2018-test-presentation'
  //public odoo_path:string = 'https://extern.hogakaprofi.de:8069'
  //public odoo_db:string = 'ws-2017-master'
  public db_prefix:string = 'HoGaKa_KD'
  public db_collections = {
    "login": [],
    "jobs": [
      'name',
      ['fulltext_search', {multiEntry: true}],
    ],
    "products": [
      'id',
      ['fulltext_search', {multiEntry: true}],
    ],
    "system": [],
    "replacement_items": [
      "product_index",
      "state",
    ],
    "design": [],
  }
}



// WEBPACK FOOTER //
// ./src/assets/app.config.ts